import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function Chip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        'btn-press border px-3 py-[7px] text-[12px] font-semibold cursor-pointer',
        active ? 'bg-accent text-bg border-accent' : 'bg-transparent text-ink border-stroke',
      )}
    >
      {children}
    </button>
  );
}
